import { Button, colors, Theme, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const getCellColor = (positive: boolean | null | undefined, theme: Theme): string => {
  if (positive === true) return colors.green[700];
  if (positive === false) return colors.red[600];
  return theme.palette.text.primary;
};

export const ControlsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));

export const SummaryStatsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(1.5),
  flexWrap: 'wrap',
}));

export const StatBlock = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
}));

export const StatLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.68rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
})) as typeof Typography;

export const StatValue = styled(Typography)(({ theme }) => ({
  fontSize: '0.92rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
})) as typeof Typography;

export const FinancialTable = styled('table')(() => ({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
}));

export const FinancialTableRow = styled('tr')(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.grey[50],
  },
}));

export const FinancialTableHead = styled('th')(({ theme }) => ({
  padding: '6px 8px',
  fontSize: '0.68rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  textAlign: 'right',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  whiteSpace: 'nowrap',
  '&:first-of-type': {
    textAlign: 'left',
  },
}));

export const FinancialTableCell = styled('td', {
  shouldForwardProp: prop => prop !== 'positive',
})<{ positive?: boolean | null }>(({ theme, positive }) => ({
  padding: '5px 8px',
  fontSize: '0.78rem',
  textAlign: 'right',
  color: getCellColor(positive, theme),
  '&:first-of-type': {
    textAlign: 'left',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}));

export const EstBadge = styled('span')(({ theme }) => ({
  display: 'inline-block',
  fontSize: '0.6rem',
  fontWeight: 700,
  lineHeight: 1,
  padding: '2px 4px',
  borderRadius: 3,
  backgroundColor: colors.orange[50],
  color: colors.orange[800],
  border: `1px solid ${colors.orange[200]}`,
  marginLeft: theme.spacing(0.5),
  verticalAlign: 'middle',
}));

export const ShowAllButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'none',
  color: theme.palette.primary.main,
  padding: 0,
  minWidth: 0,
  '&:hover': {
    background: 'none',
    textDecoration: 'underline',
  },
}));
